import api from "./api";

// Chunked upload → object storage. onProgress(0..100)
export async function uploadFile(file, kind = "media", onProgress = () => {}) {
  const { data: init } = await api.post("/uploads/init", { filename: file.name, size: file.size, kind });
  const size = init.chunk_size;
  const total = Math.ceil(file.size / size);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * size, Math.min(file.size, (i + 1) * size));
    await api.post(`/uploads/${init.upload_id}/chunk?index=${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress(Math.round(((i + 1) / total) * 95));
  }
  const { data } = await api.post(`/uploads/${init.upload_id}/complete`);
  onProgress(100);
  return data; // { file_id, url, content_type, size }
}

export const fileUrl = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
